import { getSiteAffiliate } from './services/utils/affiliate.service';

export const languageMappings = (langCode: string): string => {
  const affiliate = getSiteAffiliate();
  if (langCode === 'en' && affiliate === 'Ireland') {
    return 'en-IE';
  }
  if (langCode === 'en' && affiliate === 'USA') {
    return 'en-US';
  }
  if (langCode === 'en' && affiliate === 'Canada') {
    return 'en-CA';
  }
  if (langCode === 'de' && affiliate === 'Switzerland') {
    return 'ch-de'
  }
  if (langCode === 'en') {
    return 'en-GB';
  }
  return langCode;
};

export const getLanguageFile = async (
  languageCode: string
): Promise<unknown> => {
  const languageCodeForFile = languageMappings(languageCode);
  const langFile = await import(
    /* webpackChunkName: "locale-[request]" */ `./locales/${languageCodeForFile}.json`
  );
  return {
    [languageCode]: langFile,
  };
};
